import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TasksService } from 'src/app/services/tasks.service';
import { ngxCsv } from 'ngx-csv/ngx-csv';
import { BreadcrumbService } from 'xng-breadcrumb';
import { SettlementsService } from 'src/app/services/settlements.service';
import { DateService } from 'src/app/shared/services/date.service';
import { SummaryService } from 'src/app/services/summary.service';
import { IconsService } from 'src/app/shared/services/icons.service';
import { ModalSettlementStatementComponent } from 'src/app/components/modals/modal-settlement-statement.component';
import { ModalSettlementBillReportComponent } from 'src/app/components/modals/modal-settlement-bill-report.component';

@Component({
  selector: 'app-dashboard-commercial',
  template: `
    <div class="d-flex">
      <div clas="flex-column">
        <div class="row mb-4 mt-4">
          <div class="col-md-6">
              <xng-breadcrumb ></xng-breadcrumb>
            <div class="row">
              <div class="col-md-8">
              <h1 class="mt-3">Tablero</h1>
                <h5 class="mb-0">Condominio</h5>
                <h1>{{settlement.settlement?.name}}</h1>
              </div>
              <div class="col-md-12">
                <p class="mb-2"><small>{{settlement.settlement?.address}}, {{settlement.settlement?.city}}, {{settlement.settlement?.country}}</small></p>
                <p class="mb-0" style="font-size: 17px;"><small>{{settlement.settlement?.email}}</small></p>
                <p class="mb-" style="font-size: 17px;"><small>{{settlement.settlement?.phone}}</small></p>
                <hr>
              </div>
              <div class="col-12">
                <div class="card rounded-5 shadow">
                  <div class="card-body p-4">
                    <div class="d-flex">
                      <!-- div class="flex-fill">
                        <button type="button" class="btn btn-outline-primary rounded-4" (click)="generateStatement()">Generar Estado de cuenta</button>
                      </!-->
                      <div class="flex-fill">
                        <button type="button" class="btn btn-outline-primary rounded-4 ms-2" (click)="generateReport()">Generar reporte</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 text-end mt-2">
            <div class="card rounded-5 shadow">
              <div class="card-body p-4" *ngIf="portafolio.past_due">
                <div class="row">
                  <div class="col-md-6 text-center">
                    <h1 [countUp]="avg"></h1>
                    <p>Calificación</p>
                  </div>
                  <div class="col-md-6 text-center">
                    <h1 [countUp]="stats.length"></h1>
                    <p>Tareas acumuladas</p>
                  </div>
                  <div class="col-md-6 text-center">
                    <h1 [countUp]="settlement.tanques?.length"></h1>
                    <p>Tanques</p>
                  </div>
                  <div class="col-md-6 text-center">
                    <h1 [countUp]="settlement.units?.length"></h1>
                    <p>Unidades</p>
                  </div>
                  
                  <div class="col-md-6 text-center">
                    <app-pie-chart-portfolio [data]="portafolio"></app-pie-chart-portfolio>
                  </div>
                  <div class="col-md-6 text-center mt-5">
                    <h2 [countUp]="portafolio.past_due" [currency]="'$'"></h2>
                    <p>Cartera vencida</p>
                    <h2 [countUp]="portafolio.current" [currency]="'$'"></h2>
                    <p>Cartera vigente</p>
                  </div>
                  <div class="col-12 text-center">
                    <p class="text-muted text-sm">La cartera se consideran todos los recibos emitidos generados.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-md-12">
            <div class="card rounded-5 shadow mb-5" id="cardConsumptions" #cardConsumptions>
              <div class="card-body py-4 px-5">
                <div class="row">
                  <div class="col-12">
                    <h5>Consumo del periodo</h5>
                  </div>
                  <div class="col-12" *ngIf="consumption_consumptions.length>0">
                    <app-line-chart-consumption
                      [data]="consumption_consumptions"
                      [start_date]="payload.start_date"
                      [end_date]="payload.end_date"
                    ></app-line-chart-consumption>
                  </div>
                  <div class="col-12" *ngIf="consumption_consumptions.length==0">
                    <div class="text-center py-5" >
                      <img src="/assets/images/empty-state.png" width="240px">
                      <p class="text-muted">No se encontraron registros</p>
                    </div>
                  </div>
                </div>                
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="card rounded-5 shadow mb-5" id="cardConsumptions" #cardConsumptions >
              <div class="card-body py-4 px-5" >
                <div class="row">
                  <div class="col-12">
                    <h5>Lts. Trabajados VS Lts. Consumidos</h5>
                  </div>
                  <div class="col-12" *ngIf="consumption_tanques.length>0">
                    <app-stl-bar-chart-consumptions
                      [data]="consumption_data"
                    ></app-stl-bar-chart-consumptions>
                  </div>
                  <div class="col-12" *ngIf="consumption_tanques.length==0">
                    <div class="text-center py-5" >
                      <img src="/assets/images/empty-state.png" width="240px">
                      <p class="text-muted">No se encontraron registros</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- div class="col-md-7">
            <div class="card rounded-5 shadow mb-5">
              <div class="card-body py-4 px-5">
                <div class="row">
                  <div class="col-md-12">
                    
                  </div>
                  <div class="col-md-12 mt-4">
                    <table class="table table-sm">
                      <tr>
                        <th>Calificación prom.</th>
                        <th>Tarea</th>
                        <th>Técnico</th>
                        <th>Fecha</th>
                      </tr>
                      <tr *ngFor="let stat of stats">
                        <td>{{stat.avg_grade}}</td>
                        <td>{{stat.task_id}}</td>
                        <td>{{stat.user_id}}</td>
                        <td>{{stat.created_at | date: 'dd/MM/yy'}}</td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </!-->
          <!-- div class="col-md-5">
            <div class="card rounded-5 shadow">
              <div class="card-body py-4 px-5">
                <div class="row" *ngIf="stats.length>0">
                  <app-bar-chart [multi]="stats"></app-bar-chart>
                </div>
              </div>
            </div>
          </!-->
        </div>
      </div>
    </div>
    <!-- app-modal-settlement-bill-report></!-->
    <!-- app-modal-settlement-statement [settlement]="settlement"></!-->
  `,
  styleUrls: []
})
export class DashboardCommercialComponent {
  @ViewChild(ModalSettlementStatementComponent, { static: true }) modalSettlementStatement !: ModalSettlementStatementComponent;
  @ViewChild(ModalSettlementBillReportComponent, { static: true }) modalSettlementBillReport !: ModalSettlementBillReportComponent;
  settlementId: number = 0;
  stats: any[] = [];
  avg: number = 0;
  settlement: any = {};
  portafolio: any = {};

  selectedYear: any;
  selectedMonth: any;

  periodos: any[] = [
    {id: 1, name: 'Enero 2024'},
    {id: 2, name: 'Febrero 2024'},
    {id: 3, name: 'Marzo 2024'},
    {id: 4, name: 'Abril 2024'},
    {id: 5, name: 'Mayo 2024'},
    {id: 6, name: 'Junio 2024'},
    {id: 7, name: 'Julio 2024'},
    {id: 8, name: 'Agosto 2024'},
    {id: 9, name: 'Septiembre 2024'},
    {id: 10, name: 'Octubre 2024'},
    {id: 11, name: 'Noviembre 2024'},
    {id: 12, name: 'Diciembre 2024'},
  ];

  years: any[] = [
    {id: 2024, name: '2024'},
    {id: 2025, name: '2025'},
    {id: 2026, name: '2026'},
    {id: 2027, name: '2027'},
  ]

  payload: any = {
    id: 0,
    year: 2024,
    month: 4,
  };

  consumption_data: any[] = [];
  consumption_consumptions: any[] = [];
  consumption_tanques: any[] = [];

  constructor(
    private store: SettlementsService,
    private summ: SummaryService,
    private tasksService: TasksService,
    private activateRoute: ActivatedRoute,
    private route: Router,
    private breadcrumbService: BreadcrumbService,
    private dateService: DateService,
    public icons: IconsService
  ) {
    this.activateRoute.params.subscribe(params => {
      this.settlementId = params['id'];
      this.payload.settlement_id = this.settlementId;
      this.payload.id = this.settlementId;

      this.loadSettlement();
    });
  }

  ngOnInit(): void {
    this.loadStatSummary();
    // this.updatePeriodo(this.dateService.getPeriodo(new Date()));    
    this.loadPortafolio();
    this.loadTankSummary();
  }

  loadSettlement() {
    this.store.getSettlementNested(this.settlementId).subscribe((response: any) => {
      console.log('settlement response => ', response);
      this.settlement = response;
      this.breadcrumbService.set('@settlementName', this.settlement.name); 
      this.breadcrumbService.set('@dashboard', `Tablero de condominio`);      
    });
  }

  loadStatSummary() {
    console.log('payload ===> ', this.payload);
    this.tasksService.getTechStatSummariesFilter(this.payload).subscribe((response: any) => {
      console.log("getTechStatSummariesFilter ===> ", response);
      this.stats = response.data;
      
      let local_avg = 0;
      response.data.map((item: any) => {
        local_avg += item.avg_grade;
      });
      if (response.data.length > 0) {
        this.avg = local_avg / response.data.length;
      } else {
        this.avg = 0;
      }
    })
  }

  loadTankSummary() {
    console.log('loadTankSummary settlementId => ', this.settlementId);
    console.log('payload ===> ', this.payload);
    // { id: this.settlementId, year: 2024, month: 4}
    this.summ.getConsumeSummaryBySettlementMonth(this.payload).subscribe((data: any) => {
      console.log('getTanqueSummary data => ', data);
      this.consumption_data = data;
      this.consumption_consumptions = data.consumptions;
      this.consumption_tanques = data.readings;
    });
  }

  loadPortafolio() {
    this.store.getBillsPortafolioSettlement({ profile_id: 1, settlement_id: this.settlementId }).subscribe((response: any) => {
      console.log('getBillsPortfolio response => ', response);
      this.portafolio = response;
    });
  }

  updateYear(event: any) {
    console.log('updateYear', event.target.value);
    this.payload.year = event.target.value;
  }

  updatePeriodo(event: any) {
    console.log('updatePeriodo', event.target.value);
    this.payload.month = event.target.value;
    // const year = 2024;
    // let month = event.target ? event.target.value : event;

    // const startDate = new Date(year, month - 1, 1);
    // const endDate = new Date(year, month, 0);

    // this.payload.start_date = startDate.toISOString().substring(0, 10), // Format as "YYYY-MM-DD"
    // this.payload.end_date = endDate.toISOString().substring(0, 10) // Format as "YYYY-MM-DD"
    
    // this.loadStatSummary();
  }

  updateReport() {
    this.loadTankSummary();
  }

  generateReport() {
    console.log('generateReport');
    console.log('payload => ', this.payload);
    console.log('modalSettlementStatement => ', this.modalSettlementStatement);
    // TODO: Get all bills for the period
    // And link the tank to the bill
    const modalTemplate: any | undefined = this.modalSettlementStatement;
    if (modalTemplate) {
      this.modalSettlementStatement.openModal(modalTemplate['modalSettlementStatement']);
    }
  }
}
